import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const Title = styled.h2`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(3)};
  width: 100%;
  text-align: center;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(4)};
  }
`
export const NearbyStoresContainer = styled.div`
  margin-bottom: ${spacing(6)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(10)};
  }
`
export const StoreCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(2)};
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 ${spacing(2)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    flex-direction: row;
    overflow-x: auto;
    align-items: flex-start;
  }
`
